import { render, staticRenderFns } from "./CompBusinessYearCRUD.vue?vue&type=template&id=0beb08ed&"
import script from "./CompBusinessYearCRUD.vue?vue&type=script&lang=js&"
export * from "./CompBusinessYearCRUD.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports